/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { isNullOrUndefined } from './utils'

type ServiceColProps = {
  value: number | null
}

const formatValue = (value: number) => {
  if (isNullOrUndefined(value)) {
    return ''
  }
  const v = Number(value)
  if (isNaN(v)) {
    return ''
  }
  return v >= 0 ? v.toString() : 'Over due by ' + -v
}

const ServiceCol: React.FC<ServiceColProps> = ({ value }) => {
  const displayBlank = isNullOrUndefined(value)

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = formatValue(value)
  }

  return <AssetTableCell>{displayValue}</AssetTableCell>
}

export default ServiceCol
